const {rootMenuDropdownAndDropdownMenuDefaultStyleProperties} = require('./constants')
const {normalizeAlign} = require('../utils')

/**
 * @typedef {import('./../types.js').MenuStyleProperties} MenuStyleProperties
 */

/**
 * @param {MenuStyleProperties} stylesProps
 * @param {Object} componentProps
 * */
const migrateSubmenuLayout = (stylesProps, componentProps) => {
    if (componentProps.submenuMode === 'flyout') {
        migrateSubmenuFlyoutLayout(stylesProps)
        migrateSubmenuFlyoutLayoutAlignment(stylesProps)
    } else {
        migrateSubmenuColumnsLayoutStretching(stylesProps, componentProps.submenuMode)
        migrateSubmenuColumnsLayoutNumberOfColumns(stylesProps)
        migrateSubmenuColumnsLayoutColumnsSpacing(stylesProps)
    }
    migrateSubmenuVerticalDistanceFromMenu(stylesProps)
    migrateSubmenuItemSpacing(stylesProps)
    migrateSubmenuItemPadding(stylesProps)
    migrateSubmenuItemAlign(stylesProps)
    addRootMenuDropdownAndDropdownMenuDefaultsIfNeeded(stylesProps)
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuItemSpacing = styles => {
    styles['dropdown-menu-item-vertical-spacing'] = styles['submenu-item-margin-bottom']
    styles['dropdown-menu-sub-items-vertical-spacing-before'] = styles['submenu-item-margin-bottom']
    styles['dropdown-menu-sub-items-vertical-spacing-between'] = styles['submenu-item-margin-bottom']
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuItemPadding = styles => {
    styles['dropdown-menu-item-vertical-padding'] = styles['submenu-item-padding-top']
    styles['dropdown-menu-item-horizontal-padding'] = styles['submenu-item-padding-left']
    styles['dropdown-menu-sub-item-vertical-padding'] = styles['submenu-item-padding-top']
    styles['dropdown-menu-sub-item-horizontal-padding'] = styles['submenu-item-padding-left']
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuItemAlign = styles => {
    styles['dropdown-menu-align'] = normalizeAlign(styles['submenu-item-container-justify-content'])
    styles['dropdown-menu-item-align'] = normalizeAlign(styles['submenu-item-container-justify-content'])
    styles['dropdown-menu-sub-item-align'] = normalizeAlign(styles['submenu-item-container-justify-content'])
}

/**
 * @param {MenuStyleProperties} styles
 * @param {string} submenuMode
 */
const migrateSubmenuColumnsLayoutStretching = (styles, submenuMode) => {
    if (submenuMode === 'columnStretched') {
        styles['dropdown-anchor'] = 'screen'
        styles['dropdown-horizontal-margin'] = styles['submenu-position-box-margin-left']
    } else {
        styles['dropdown-anchor'] = 'menuStretched'
        styles['dropdown-horizontal-margin'] = '0px'
    }
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuColumnsLayoutNumberOfColumns = styles => {
    styles['dropdown-menu-columns-number'] = styles['submenu-list-wrapper-column-count']
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuColumnsLayoutColumnsSpacing = styles => {
    styles['dropdown-menu-item-horizontal-spacing'] = styles['submenu---horizontalSpacing']
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuVerticalDistanceFromMenu = styles => {
    styles['dropdown-space-above'] = styles['submenu-margin-top']
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuFlyoutLayout = styles => {
    styles['dropdown-menu-columns-number'] = '1'
    styles['dropdown-anchor'] = 'menuItem'
}

/**
 * @param {MenuStyleProperties} styles
 */
const migrateSubmenuFlyoutLayoutAlignment = styles => {
    const alignment = styles['submenu---flyoutAlignment']

    if (!alignment) return

    if (alignment === 'center') {
        styles['dropdown-align'] = 'center'
    } else {
        styles['dropdown-align'] = 'start'
    }
}

/**
 * @param {MenuStyleProperties} styles
 */
const addRootMenuDropdownAndDropdownMenuDefaultsIfNeeded = styles => {
    Object.entries(rootMenuDropdownAndDropdownMenuDefaultStyleProperties).forEach(([key, value]) => {
        if (!styles[key]) {
            styles[key] = value
        }
    })
}

module.exports = {
    migrateSubmenuLayout
}
